export default __webpack_public_path__ + "static/media/bicycle.84601492.png";